import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { isIdType } from 'types/utils';
function defaultGetItemId(item) {
  if (!isIdType(item)) {
    throw Error('uniq: Could not retrieve item ID');
  }
  return item;
}

/**
 * Remove duplicate items from an array.
 */

function uniq(
/**
 * Array of items to be de-duplicated
 */
items) {
  var getItemId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetItemId;
  // A Map, not an object: object keys that look like integers are enumerated in ascending
  // numeric order, which silently re-sorts items by id instead of keeping the given order
  var itemsById = new Map();
  items.forEach(function (item) {
    var id = String(getItemId(item));
    if (!itemsById.has(id)) {
      itemsById.set(id, item);
    }
  });
  return _toConsumableArray(itemsById.values());
}
export default uniq;